import usePayment from '@/usePayment';

const { translate: paymentMethodTranslate } = usePayment();
export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _secondaryControls: {
      width: '3rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
    },
    contactName: {
      name: 'ชื่อผู้ติดต่อ',
      width: '8rem',
    },
    contactTelephone: {
      name: 'เบอร์โทรศัพท์ผู้ส่ง',
      width: '10rem',
      filter: (val: any, row: any) => `${row.item?.address?.telephone || ''}`,
    },
    senderName: {
      name: 'ชื่อผู้ส่ง',
      width: '8rem',
    },
    senderAddress: {
      name: 'ที่อยู่ผู้ส่ง',
      width: '30rem',
    },
    orderNumber: {
      name: 'หมายเลข Order',
      width: '8rem',
    },
    orderDate: {
      name: 'วันรับออเดอร์',
      width: '10rem',
    },
    area: {
      name: 'เขตจัดส่ง',
      width: '14rem',
      class: 'text-center',
    },
    deliveryArea: {
      name: 'Lat / Long',
      width: '8rem',
      class: 'text-center',
    },
    customerName: {
      name: 'ชื่อลูกค้า',
      width: '8rem',
    },
    address: {
      name: 'ที่อยู่ผู้รับ',
      width: '30rem',
    },
    'address.telephone': {
      name: 'เบอร์โทรศัพท์',
      width: '8rem',
    },
    deliveryFee: {
      name: 'ค่าขนส่ง',
      width: '6rem',
    },
    urgentLevel: {
      name: 'ความเร่งด่วน',
      width: '8rem',
    },
    paymentType: {
      name: 'การชำระเงิน',
      width: '8rem',
      filter: (val: string) => paymentMethodTranslate(val),
    },
    remarks: {
      name: 'หมายเหตุ',
      width: '10rem',
    },
  },
};
